<template>
  <div class="content-container flex-row">
    <TheLoader :active="loading || updating" :update="updating" :small="true"/>

    <section class="content xlarge-padding white">
      <TheEmptyList v-if="!loading && items.length < 1" :title="'Ubehandlede'" :message="'Fant ingen bekreftelsebrev'" :large="false" :icon="'button-glyph-contract'"/>
      <table v-else class="large fixed visible" style="width: 100%">
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th>ID</th>
          <th>Kundenr</th>
          <th>Navn</th>
          <th>Avdeling</th>
          <th>Auksjon</th>
          <th>Dato generert</th>
          <th class="align-center">Antall objekter</th>
          <th>Type</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" v-bind:key="item.id">
          <td>
            <div class="flex-container">
              <div class="input-container checkbox">
                <input type="checkbox" :value="item.id" v-model="selected">
                <span class="glyph"><svg viewBox="0 0 16 16"><use
                  xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
              </div>
            </div>
          </td>
          <td>{{ item.id }}</td>
          <td>{{ item.Kundenr }}</td>
          <td>{{ item.template_data.Navn || '-' }}</td>
          <td>{{ item.avdeling ? item.avdeling.Beskrivelse : '-' }}</td>
          <td>{{ item.Auksjonskode || '-' }}</td>
          <td>{{ item.Registrert_dato | avantidate }}</td>
          <td class="align-center">{{ itemCount(item) }}</td>
          <td>{{ item.AvantiType === 'automatic' ? 'E-post' : 'Manuell' }}</td>
        </tr>
      </tbody>
      </table>

      <div class="checkbox-panel-container" :class="{'active': selected.length > 0}">
        <div class="checkbox-panel">
          <div class="grid-x">
            <div class="cell auto">
              <div class="input-container checkbox">
                <input type="checkbox" id="checkall-objekter" @click="toggleSelectAll($event)" :checked="selected.length === items.length">
                <label for="checkall-objekter">Marker alle</label>
                <span class="glyph"><svg viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
              </div>
            </div>
            <div class="cell shrink">
              <span class="count"><span class="checked">{{selected.length}}</span> / <span class="total">{{items.length}}</span> markert</span>
            </div>
            <div class="cell shrink" v-if="!loading && !updating">
              <a href="javascript:;" @click="approveSelected()" class="button secondary">Godkjenn (Legg til i kø for utsending)</a>
              <a href="javascript:;" @click="deleteSelected()" class="button secondary">Slett</a>
              <a href="javascript:;" @click="printSelected()" class="button primary">Vis / skriv ut</a>
            </div>
            <div class="cell shrink" v-else>
              <a href="javascript:;" class="button secondary" disabled>Godkjenn (Legg til i kø for utsending)</a>
              <a href="javascript:;" class="button secondary" disabled>Slett</a>
              <a href="javascript:;" class="button primary" disabled>Vis / skriv ut</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import BekreftelsebrevService from '@/services/BekreftelsebrevService'
import bus from '@/plugins/event-bus'

export default {
  name: 'BekreftelsebrevUbehandlade',
  data () {
    return {
      loading: false,
      updating: false,
      items: [],
      pages: 1,
      params: null,
      selected: []
    }
  },
  created () {
    bus.$off('reload-bekreftelsebrev')
    bus.$off('update-selected-status')
  },
  mounted () {
    bus.$on('reload-bekreftelsebrev', () => this.resetAndReload())
    bus.$on('update-selected-status', () => this.updateSelectedStatus())
  },
  activated () {
    this.loading = true

    this.setDefaultParams()
    this.fetch()
  },
  methods: {
    toggleSelectAll: function (event) {
      if (event.target.checked) {
        // Checked: true -> add all objektids to the selected-array
        this.selected = []
        this.items.forEach(i => {
          this.selected.push(i.id)
        })
      } else {
        // Just empty selected-array
        this.selected = []
      }
    },
    printSelected: function () {
      this.openModal('bekreftelsebrev-print-modal', { items: this.selected, internalWindow: true, skipSave: true }, 'split')
    },
    deleteSelected: function () {
      var vm = this

      this.openConfirm(
        'Slett markerte bekreftelsebrev.',
        'Er du sikker på du vil slette markerte bekreftelsebrev?',
        'Ja',
        'Nei',
        function () {
          vm.closeModal()
          vm.deleteDrafts()
        },
        function () {
          vm.closeModal()
        }
      )
    },
    deleteDrafts: function () {
      this.updating = true
      this.$emit('onSubmitStatusChange', 'updating')

      BekreftelsebrevService.deleteDrafts(this.selected)
        .then((response) => {
          if (response.data.success) {
            this.selected.forEach(id => {
              let foundIndex = this.items.findIndex(x => x.id === id)
              if (foundIndex !== -1) {
                this.items.splice(foundIndex, 1)
              }
            })

            this.selected = []
            this.$helpers.showSuccessAlert('Bekreftelsebrev har blitt slettet')
          } else {
            this.$helpers.showErrorAlert('Feil', 'Kunne ikke slette')
          }
        })
        .catch((error) => {
          console.log('Error')
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke slette')
        })
        .then(() => {
          this.updating = false
          this.$emit('onSubmitStatusChange', 'submittable')
        })
    },
    approveSelected: function () {
      var vm = this

      this.openConfirm(
        'Send markerte bekreftelsebrev på e-post.',
        'Er du sikker på du vil sende markerte bekreftelsebrev på epost?',
        'Ja',
        'Nei',
        function () {
          vm.closeModal()
          vm.setApproved()
        },
        function () {
          vm.closeModal()
        }
      )
    },
    setApproved: function () {
      this.updating = true

      this.$emit('onSubmitStatusChange', 'updating')

      BekreftelsebrevService.approveMany(this.selected)
        .then((response) => {
          if (response.data.success) {
            this.selected.forEach(id => {
              let foundIndex = this.items.findIndex(x => x.id === id)
              if (foundIndex !== -1) {
                this.items.splice(foundIndex, 1)
              }
            })

            this.selected = []
            this.$helpers.showSuccessAlert('Bekreftelsebrev(ene) har blitt lagt til i kø for utsending')
          } else {
            this.$helpers.showErrorAlert('Feil', 'Kunne ikke legge til bekreftelsebrev(ene) i kø for utsending')
          }
        })
        .catch((error) => {
          console.log('Error')
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke legge til bekreftelsebrev(ene) i kø for utsending')
        })
        .then(() => {
          this.updating = false
          this.$emit('onSubmitStatusChange', 'submittable')
        })
    },
    itemCount: function (item) {
      return Object.keys(item.template_data.objects).length
    },
    setDefaultParams: function () {
      this.params = {
        type: 'automatic',
        page: 1,
        sort: 'id',
        direction: 'desc',
        limit: 1000
      }
    },
    resetAndReload: function () {
      this.updating = true
      this.$emit('onSubmitStatusChange', 'loading')
      this.setDefaultParams()
      this.fetch()
    },
    fetch: function () {
      this.selected = []

      BekreftelsebrevService.getDrafts(this.params)
        .then((response) => {
          this.pages = response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1
          this.items = response.data
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn liste')
        })
        .then(() => {
          this.loading = false
          this.updating = false
          this.$emit('onSubmitStatusChange', 'submittable')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Reports/BekreftelsebrevGodkjenning.vue